module.exports = __webpack_public_path__ + "img/introduceList4.7691167c.jpg";